import * as React from "react";
import { connect } from "react-redux";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { IdStyles } from "../../less/IdStyles";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var _MenuSettings = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(MenuWrapper, { type: IdMenuBalancing.SettingsMenu, onClose: onClose, className: IdStyles.ModalBackground, modalId: IdModal.Settings }));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () {
        dispatch(actionModalClose(IdModal.Settings));
    },
}); };
export var MenuSettings = connect(undefined, mapDispatch)(_MenuSettings);



//////////////////
// WEBPACK FOOTER
// ./src/features/settings/MenuSettings.tsx
// module id = 2898
// module chunks = 3